import { useEffect, useRef } from 'react';

import { Col, Form, Row, Button, Modal } from 'react-bootstrap';
import { AiFillCloseCircle } from 'react-icons/ai';

import styles from './Briefing.module.css';
import BriefingThumb from '../BriefingThumb';

const Briefing = props => {
  const briefingArquivo1Ref = useRef();
  const briefingArquivo2Ref = useRef();
  const briefingArquivo3Ref = useRef();
  const briefingArquivo4Ref = useRef();
  const briefingArquivo5Ref = useRef();

  useEffect(() => {
    (props.briefingArquivo1 ||
      props.briefingArquivo2 ||
      props.briefingArquivo3 ||
      props.briefingArquivo4 ||
      props.briefingArquivo5) &&
      window.scrollBy(0, 350);
  }, [props.briefingArquivo1, props.briefingArquivo2, props.briefingArquivo3, props.briefingArquivo4, props.briefingArquivo5]);

  return (
    <>
      <Row>
        <Col sm={12}>
          <Form.Group controlId="briefingPorque" className="mt-4">
            <Form.Label>*O que precisamos fazer? Por que você está fazendo esse pedido?</Form.Label>
            <Form.Control
              className="border border-secondary"
              as="textarea"
              rows={7}
              name="briefingPorque"
              onChange={e => props.handleBriefingPorque(e)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="briefingMedidas" className="mt-4">
            <Form.Label>*Quais peças devem ser desenvolvidas/criadas? Quais as medidas (largura X altura)?</Form.Label>
            <Form.Control
              className="border border-secondary"
              as="textarea"
              rows={7}
              name="briefingMedidas"
              onChange={e => props.handleBriefingMedidas(e)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="briefingOnde" className="mt-4">
            <Form.Label>*Onde serão veiculadas/expostas? (Redes sociais, portal, impressos, eventos etc.)</Form.Label>
            <Form.Control
              className="border border-secondary"
              as="textarea"
              rows={7}
              name="briefingOnde"
              onChange={e => props.handleBriefingOnde(e)}
            />
          </Form.Group>
        </Col>
      </Row>
      
      <Row>
        <Col sm={12}>
          <Form.Group controlId="briefingPrazo" className="mt-4">
            <Form.Label>*Qual é o prazo desejado para entrega do projeto? (Sujeito a análise interna e viabilidade dos pedidos na fila de produção)</Form.Label>
            <Form.Control
              type="date"
              className="border border-secondary"
              name="briefingPrazo"
              onChange={e => props.handleBriefingPrazo(e)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="briefingDetalhe" className="mt-4">
            <Form.Label>*Tem mais algum detalhe ou algum link de referência? Deixe aqui o seu comentário para inspirar a nossa equipe.</Form.Label>
            <Form.Control
              className="border border-secondary"
              as="textarea"
              rows={7}
              name="briefingDetalhe"
              onChange={e => props.handleBriefingDetalhe(e)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <p className={styles.file_title}>
          Tem algum arquivo (foto, texto ou logo) que precisamos receber? Envie anexo. (Máximo de 5 anexos com 5MB cada) <br />
          Arquivos suportados: .pdf, .png, .gif, .jpg, .jpeg, .svg, .txt, .doc, .docx, .xls, .xlsx
        </p>
      </Row>

      <Row>
        <Col sm={7}>
          <Form.Group controlId="briefingArquivo1" className="mt-4">
            <Form.Label>1º Anexo</Form.Label>
            <Form.Control
              type="file"
              className="border border-secondary"
              name="briefingArquivo1"
              onChange={e => props.handleBriefingArquivo(e, briefingArquivo1Ref)}
              ref={briefingArquivo1Ref}
            />
          </Form.Group>
        </Col>

        <Col sm={1}>
          {props.briefingArquivo1 && 
            <AiFillCloseCircle
              className={styles.file_reset_button}
              onClick={() => props.resetBriefingArquivo(briefingArquivo1Ref)}
              size={22}
            />
          }
        </Col>

        <BriefingThumb
          briefingArquivo={props.briefingArquivo1}
        />
      </Row>

      {(props.briefingArquivo1 || props.briefingArquivo2) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="briefingArquivo2" className="mt-4">
              <Form.Label>2º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="briefingArquivo2"
                onChange={e => props.handleBriefingArquivo(e, briefingArquivo2Ref)}
                ref={briefingArquivo2Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.briefingArquivo2 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetBriefingArquivo(briefingArquivo2Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.briefingArquivo2}
          />
        </Row>
      }

      {(props.briefingArquivo2 || props.briefingArquivo3) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="briefingArquivo3" className="mt-4">
              <Form.Label>3º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="briefingArquivo3"
                onChange={e => props.handleBriefingArquivo(e, briefingArquivo3Ref)}
                ref={briefingArquivo3Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.briefingArquivo3 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetBriefingArquivo(briefingArquivo3Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.briefingArquivo3}
          />
        </Row>
      }

      {(props.briefingArquivo3 || props.briefingArquivo4) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="briefingArquivo4" className="mt-4">
              <Form.Label>4º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="briefingArquivo4"
                onChange={e => props.handleBriefingArquivo(e, briefingArquivo4Ref)}
                ref={briefingArquivo4Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.briefingArquivo4 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetBriefingArquivo(briefingArquivo4Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.briefingArquivo4}
          />
        </Row>
      }

      {(props.briefingArquivo4 || props.briefingArquivo5) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="briefingArquivo5" className="mt-4">
              <Form.Label>5º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="briefingArquivo5"
                onChange={e => props.handleBriefingArquivo(e, briefingArquivo5Ref)}
                ref={briefingArquivo5Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.briefingArquivo5 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetBriefingArquivo(briefingArquivo5Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.briefingArquivo5}
          />
        </Row>
      }

      <Modal show={props.showBriefingModal} onHide={props.handleBriefingModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.briefingError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleBriefingModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Briefing;
